module.exports = __webpack_public_path__ + "static/media/5.784f9db5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/slides/5.jpg
// module id = 782
// module chunks = 0